import { render, staticRenderFns } from "./CookiesAndPrivacy.vue?vue&type=template&id=d6614d1a&"
import script from "./CookiesAndPrivacy.vue?vue&type=script&lang=js&"
export * from "./CookiesAndPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports